import type {ReactNode} from 'react';
import Brand from './Brand';
import OrdinaryNavigation,{type Destination} from './OrdinaryNavigation';
import ThemePicker,{type Theme} from './ThemePicker';

// Same header for the public role preview and the authenticated owner workspace.
// Data visibility is controlled by the authenticated route, never by CSS hiding.
type Props={
 current:Destination;
 loading?:boolean;
 theme:Theme;
 onNavigate:(page:Destination)=>void;
 onThemeChange:(theme:Theme)=>void;
 children?:ReactNode;
};
export default function SharedWorkspaceHeader({current,loading=false,theme,onNavigate,onThemeChange,children}:Props){
 return <header className="topbar">
  <Brand/>
  <OrdinaryNavigation current={current} loading={loading} onChange={onNavigate}/>
  <div className="top-actions"><ThemePicker value={theme} onChange={onThemeChange}/>{children}</div>
 </header>;
}
